import React from 'react';
import cn from 'class-names';

import { PayoutFeeOptionType } from '@ts/billing-publisher.types';

import {
  formatAmountInCurrency,
  formatEstimatedDelivery,
  formatPayoutTypeLabel,
} from '../../utils';

type Props = {
  isAmountValid: boolean;
  isFetching: boolean;
  error: string | null;
  options: PayoutFeeOptionType[] | null;
};

function FeePreview({ isAmountValid, isFetching, error, options }: Props): JSX.Element | null {
  if (!isAmountValid) {
    return (
      <div className="fee-preview fee-preview--empty">
        <span className="fee-preview__placeholder">
          Enter an amount to see the estimated transfer.
        </span>
      </div>
    );
  }
  if (isFetching) {
    return (
      <div className="fee-preview fee-preview--empty">
        <span className="fee-preview__placeholder">Estimating…</span>
      </div>
    );
  }
  if (error) {
    return (
      <div className="fee-preview fee-preview--empty">
        <span className="fee-preview__error">{error}</span>
      </div>
    );
  }
  if (!options || options.length === 0) {
    return null;
  }
  return (
    <div className="fee-preview">
      {options.map((opt) => {
        const eta = formatEstimatedDelivery(opt.estimatedDelivery);
        return (
          <div
            key={opt.payoutType}
            className={cn('fee-preview__option', {
              'fee-preview__option--disabled': opt.disabled,
            })}
          >
            <div className="fee-preview__option-row">
              <span className="fee-preview__option-label">
                {formatPayoutTypeLabel(opt.payoutType)}
              </span>
              <span className="fee-preview__option-value">
                {formatAmountInCurrency(opt.targetAmount, opt.targetCurrency)}
              </span>
            </div>
            <div className="fee-preview__option-row fee-preview__option-row--meta">
              <span>
                Estimated fee {formatAmountInCurrency(opt.feeTotal, opt.feeCurrency)}
              </span>
              {eta ? <span>Arrives {eta}</span> : null}
            </div>
          </div>
        );
      })}
      <p className="fee-preview__disclaimer">
        The fee is an estimate - the final amount may change when the transfer is created.
      </p>
    </div>
  );
}

export default FeePreview;
